<div class="dashboard">
    <div class="row w-100">
        <div class="col-12 ml-auto mr-auto p-0">
            <div class="dash-card">
                <div class="row no-gutters">
                    <!-- Título sempre visível -->
                    <div class="col-12">
                        <div class="dash-card-header"
                            style="flex-direction: column; padding-bottom: 0;">
                            <div class="row no-gutters">
                                <div
                                    class="col-12 d-flex justify-content-between align-items-center">
                                    <h2>Convites</h2>
                                    <div class="d-flex align-items-center">

                                        <app-button class="add-button"
                                            (click)="toggleModal()"
                                            *ngIf="permissionObj.canAdd">
                                            <svg-icon
                                                src="assets/images/icon-add.svg"
                                                fill="var(--white)"
                                                class="mr-2 mt-1 mb-1"></svg-icon>
                                            Novo convite
                                        </app-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Cards de Summary -->
                    <div class="col-12">
                        <div class="dash-card-body" style="padding-top: 24px;">
                            <div class="dash-card-statistics">
                                <ng-container *ngIf="loadingSummary">
                                    <div class="col-12 p-0">
                                        <div class="row w-100 m-0">
                                            <div class="pl-0 pr-2 col-4">
                                                <ngx-skeleton-loader [theme]="{
                                                    height: '89px',
                                                    width: '100%',
                                                    margin:'0'
                                                }">
                                                </ngx-skeleton-loader>
                                            </div>

                                            <div class="px-2 col-4">
                                                <ngx-skeleton-loader [theme]="{
                                                    height: '89px',
                                                    width: '100%',
                                                    margin:'0'
                                                }">
                                                </ngx-skeleton-loader>
                                            </div>

                                            <div class="pr-0 pl-2 col-4">
                                                <ngx-skeleton-loader [theme]="{
                                                    height: '89px',
                                                    width: '100%',
                                                    margin:'0'
                                                }">
                                                </ngx-skeleton-loader>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="!loadingSummary">
                                    <div class="dash-card-statistics-item">
                                        <span
                                            class="dash-card-statistics-title">
                                            Total Enviados
                                        </span>
                                        <app-spacer [bottom]="4"></app-spacer>
                                        <span
                                            class="dash-card-statistics-value">
                                            {{summaryStatistics.total}}
                                        </span>
                                    </div>

                                    <div class="dash-card-statistics-item">
                                        <span
                                            class="dash-card-statistics-title">
                                            Utilizados
                                        </span>
                                        <app-spacer [bottom]="4"></app-spacer>
                                        <span
                                            class="dash-card-statistics-value">
                                            {{summaryStatistics.used}}
                                        </span>
                                    </div>

                                    <div class="dash-card-statistics-item">
                                        <span
                                            class="dash-card-statistics-title">
                                            Expirados
                                        </span>
                                        <app-spacer [bottom]="4"></app-spacer>
                                        <span
                                            class="dash-card-statistics-value">
                                            {{summaryStatistics.expired}}
                                        </span>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <!-- Tabs -->
                    <div class="col-12">
                        <div class="dashboard-tabs-container">
                            <div class="dashboard-tabs">
                                <button type="button" class="dashboard-tab"
                                    [class.active]="activeTab === 'all'"
                                    (click)="onTabChange('all')">
                                    Todos
                                </button>
                                <button type="button" class="dashboard-tab"
                                    [class.active]="activeTab === 'assignor'"
                                    (click)="onTabChange('assignor')">
                                    Cedentes
                                </button>
                                <button type="button" class="dashboard-tab"
                                    [class.active]="activeTab === 'shareholder'"
                                    (click)="onTabChange('shareholder')">
                                    Cotistas
                                </button>
                                <button type="button" class="dashboard-tab"
                                    [class.active]="activeTab === 'provider'"
                                    (click)="onTabChange('provider')">
                                    Prestadores de serviço
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Botões de filtro com skeleton -->
                    <div class="col-12">
                        <div class="dash-card-header"
                            style="flex-direction: column; padding-top: 0;">
                            <div class="row no-gutters">
                                <div class="col-12 d-flex justify-content-between align-items-center px-0"
                                    style="margin-top: 1.75rem;">
                                    <div class="d-flex align-items-center">
                                        <button type="button"
                                            class="sort-button mr-2"
                                            (click)="refreshData()"
                                            [disabled]="loading">
                                            <svg-icon
                                                src="assets/images/icon-renew.svg"></svg-icon>
                                            <span>Atualizar</span>
                                        </button>

                                        <div class="sort-button-wrapper mr-2">
                                            <span class="sort-label">Por data de
                                                envio</span>
                                            <button type="button"
                                                class="sort-button"
                                                (click)="toggleSortButton()"
                                                [disabled]="loading">
                                                <svg-icon
                                                    src="assets/images/icon-arrow-up.svg"
                                                    *ngIf="sortButtonExpanded"></svg-icon>
                                                <svg-icon
                                                    src="assets/images/icon-arrow-down.svg"
                                                    *ngIf="!sortButtonExpanded"></svg-icon>
                                                <span>{{ getSortButtonLabel()
                                                    }}</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center">
                                        <ng-container
                                            *ngIf="permissionObj.canFilter">
                                            <app-button *ngIf="hasFilters"
                                                [danger]="true" [outline]="true"
                                                (onClick)="resetForm()"
                                                [disabled]="loading"
                                                class="add-button mr-2">
                                                <i
                                                    class="fas fa-times filter-clear-icon"></i>
                                                Limpar filtros
                                            </app-button>

                                            <app-button [inverted]="true"
                                                (onClick)="toggleFilterModal()"
                                                [disabled]="loading"
                                                class="add-button mr-2">
                                                <svg-icon
                                                    src="assets/images/icon_filter.svg"
                                                    class="mr-2">
                                                </svg-icon>
                                                {{ hasFilters ? 'Editar filtros'
                                                :
                                                'Filtrar listagem' }}
                                            </app-button>
                                        </ng-container>
                                    </div>
                                </div>

                                <!-- Tags de filtros aplicados -->
                                <div class="col-12 mt-3 px-0"
                                    *ngIf="!loading && hasFilters && appliedFilters.length > 0">
                                    <div
                                        class="d-flex flex-wrap align-items-center justify-content-end">
                                        <app-filter-tag
                                            *ngFor="let filter of appliedFilters"
                                            [label]="filter.label"
                                            [value]="filter.value">
                                        </app-filter-tag>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <app-spacer [bottom]="16"></app-spacer>
                    </div>
                </div>

                <div class="dash-card-body">
                    <div class="dash-card-scroll">
                        <table *ngIf="loading" class="bordered skeleton-table">
                            <thead>
                                <tr>
                                    <th
                                        [class.wider-column]="activeTab === 'provider'">
                                    </th>
                                    <th
                                        [class.wider-column]="activeTab === 'provider'">
                                    </th>
                                    <th
                                        [class.wider-column]="activeTab === 'provider'">
                                    </th>
                                    <th *ngIf="activeTab !== 'provider'"></th>
                                    <th
                                        [class.smaller-column]="activeTab === 'provider'">
                                    </th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let number of [0,1,2]">
                                    <!-- Nome / Razão social -->
                                    <td
                                        [class.wider-column]="activeTab === 'provider'">
                                        <div class="dash-card-item">
                                            <div
                                                class="dash-card-item-initials">
                                                <ngx-skeleton-loader
                                                    appearance="circle" [theme]="{
                                                        height: '48px',
                                                        width: '48px',
                                                        marginBottom: '0'
                                                    }">
                                                </ngx-skeleton-loader>
                                            </div>
                                            <app-spacer
                                                [right]="16"></app-spacer>
                                            <div class="dash-card-item-content">
                                                <div
                                                    class="dash-card-item-content-title">
                                                    <ngx-skeleton-loader
                                                        [theme]="{
                                                        height: '21px',
                                                        width: activeTab === 'provider' ? '280px' : '180px',
                                                        marginBottom: '0'
                                                    }">
                                                    </ngx-skeleton-loader>
                                                </div>
                                                <div
                                                    class="dash-card-item-content-subtitle">
                                                    <ngx-skeleton-loader
                                                        [theme]="{
                                                        height: '18px',
                                                        width: activeTab === 'provider' ? '300px' : '200px',
                                                        marginBottom: '0'
                                                    }">
                                                    </ngx-skeleton-loader>
                                                </div>
                                            </div>
                                        </div>
                                    </td>

                                    <!-- CPF / CNPJ -->
                                    <td
                                        [class.wider-column]="activeTab === 'provider'">
                                        <ngx-skeleton-loader [theme]="{
                                            height: '21px',
                                            width: activeTab === 'provider' ? '180px' : '140px',
                                            marginBottom: '0'
                                        }">
                                        </ngx-skeleton-loader>
                                    </td>

                                    <!-- Papel -->
                                    <td
                                        [class.wider-column]="activeTab === 'provider'">
                                        <div class="dash-card-item-content">
                                            <div
                                                class="dash-card-item-content-title">
                                                <ngx-skeleton-loader [theme]="{
                                                    height: '21px',
                                                    width: activeTab === 'provider' ? '220px' : '100px',
                                                    marginBottom: '0'
                                                }">
                                                </ngx-skeleton-loader>
                                            </div>
                                            <div
                                                class="dash-card-item-content-subtitle">
                                                <ngx-skeleton-loader [theme]="{
                                                    height: '18px',
                                                    width: activeTab === 'provider' ? '240px' : '120px',
                                                    marginBottom: '0'
                                                }">
                                                </ngx-skeleton-loader>
                                            </div>
                                        </div>
                                    </td>

                                    <!-- Fundo de interesse -->
                                    <td *ngIf="activeTab !== 'provider'">
                                        <div class="dash-card-item-content">
                                            <div
                                                class="dash-card-item-content-title">
                                                <ngx-skeleton-loader [theme]="{
                                                    height: '21px',
                                                    width: '180px',
                                                    marginBottom: '0'
                                                }">
                                                </ngx-skeleton-loader>
                                            </div>
                                            <div
                                                class="dash-card-item-content-subtitle">
                                                <ngx-skeleton-loader [theme]="{
                                                    height: '18px',
                                                    width: '140px',
                                                    marginBottom: '0'
                                                }">
                                                </ngx-skeleton-loader>
                                            </div>
                                        </div>
                                    </td>

                                    <!-- Enviado em -->
                                    <td
                                        [class.smaller-column]="activeTab === 'provider'">
                                        <div class="dash-card-item-content">
                                            <div
                                                class="dash-card-item-content-title">
                                                <ngx-skeleton-loader [theme]="{
                                                    height: '21px',
                                                    width: activeTab === 'provider' ? '90px' : '100px',
                                                    marginBottom: '0'
                                                }">
                                                </ngx-skeleton-loader>
                                            </div>
                                            <div
                                                class="dash-card-item-content-subtitle">
                                                <ngx-skeleton-loader [theme]="{
                                                    height: '18px',
                                                    width: activeTab === 'provider' ? '70px' : '80px',
                                                    marginBottom: '0'
                                                }">
                                                </ngx-skeleton-loader>
                                            </div>
                                        </div>
                                    </td>

                                    <!-- Status -->
                                    <td>
                                        <div class="status-badge-container">
                                            <ngx-skeleton-loader [theme]="{
                                                height: '28px',
                                                width: '100px',
                                                borderRadius: '20px',
                                                marginBottom: '0'
                                            }">
                                            </ngx-skeleton-loader>
                                        </div>
                                    </td>

                                    <!-- Data/hora do status -->
                                    <td>
                                        <div class="dash-card-item-content">
                                            <div
                                                class="dash-card-item-content-title">
                                                <ngx-skeleton-loader [theme]="{
                                                    height: '21px',
                                                    width: '100px',
                                                    marginBottom: '0'
                                                }">
                                                </ngx-skeleton-loader>
                                            </div>
                                            <div
                                                class="dash-card-item-content-subtitle">
                                                <ngx-skeleton-loader [theme]="{
                                                    height: '18px',
                                                    width: '80px',
                                                    marginBottom: '0'
                                                }">
                                                </ngx-skeleton-loader>
                                            </div>
                                        </div>
                                    </td>

                                    <!-- Ações -->
                                    <td style="text-align: right;">
                                        <div
                                            class="d-flex justify-content-end align-items-center">
                                            <div class="mr-3">
                                                <ngx-skeleton-loader [theme]="{
                                                    height: '20px',
                                                    width: '20px',
                                                    borderRadius: '4px',
                                                    marginBottom: '0'
                                                }">
                                                </ngx-skeleton-loader>
                                            </div>
                                            <ngx-skeleton-loader [theme]="{
                                                height: '20px',
                                                width: '20px',
                                                borderRadius: '4px',
                                                marginBottom: '0'
                                            }">
                                            </ngx-skeleton-loader>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <app-spacer [bottom]="28"></app-spacer>
                        </table>

                        <table *ngIf="invites && invites.length> 0 && !loading">
                            <thead>
                                <tr>
                                    <th
                                        [class.wider-column]="activeTab === 'provider'">
                                        Nome / Razão social</th>
                                    <th
                                        [class.wider-column]="activeTab === 'provider'">
                                        CPF / CNPJ</th>
                                    <th
                                        [class.wider-column]="activeTab === 'provider'">
                                        Papel</th>
                                    <th *ngIf="activeTab !== 'provider'">Fundo
                                        de interesse</th>
                                    <th
                                        [class.smaller-column]="activeTab === 'provider'">
                                        Enviado em</th>
                                    <th>Status</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of invites">
                                    <td
                                        [class.wider-column]="activeTab === 'provider'">
                                        <div class="dash-card-item">
                                            <div
                                                class="dash-card-item-initials">
                                                <span>{{getInitials(item)}}</span>
                                            </div>

                                            <app-spacer
                                                [right]="16"></app-spacer>
                                            <div class="dash-card-item-content">
                                                <div
                                                    class="dash-card-item-content-title">
                                                    {{item.name ?? '-'}}
                                                </div>
                                                <div
                                                    class="dash-card-item-content-subtitle">
                                                    {{item.email}}
                                                </div>
                                            </div>
                                        </div>
                                    </td>

                                    <td
                                        [class.wider-column]="activeTab === 'provider'">
                                        <div class="dash-card-item-content">
                                            <div
                                                class="dash-card-item-content-title">
                                                {{item.document || '-'}}
                                            </div>
                                        </div>
                                    </td>

                                    <td
                                        [class.wider-column]="activeTab === 'provider'">
                                        <div class="dash-card-item-content">
                                            <div
                                                class="dash-card-item-content-title">
                                                {{getTypeDisplay(item.type)}}
                                            </div>
                                            <div class="dash-card-item-content-subtitle"
                                                *ngIf="getPersonTypeDisplay(item.person_type)">
                                                {{getPersonTypeDisplay(item.person_type)}}
                                            </div>
                                            <div class="dash-card-item-content-subtitle"
                                                *ngIf="item.type === 'provider'">
                                                {{displayAgents(item.agent)}}
                                            </div>
                                        </div>
                                    </td>

                                    <td *ngIf="activeTab !== 'provider'">
                                        {{item.fund_interest_name || '-'}}
                                    </td>

                                    <td
                                        [class.smaller-column]="activeTab === 'provider'">
                                        <div class="dash-card-item-content">
                                            <div
                                                class="dash-card-item-content-title">
                                                {{displaySendDate(item.sent_at
                                                || item.created_at).date}}
                                            </div>
                                            <div
                                                class="dash-card-item-content-subtitle">
                                                {{displaySendDate(item.sent_at
                                                || item.created_at).time}}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="status-badge-container">
                                            <span
                                                [class]="getStatusBadgeClass(item)"
                                                class="status-badge">
                                                {{displayStatus(item).status}}
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="dash-card-item-content">
                                            <div
                                                class="dash-card-item-content-title">
                                                {{getStatusDateTime(item).date}}
                                            </div>
                                            <div class="dash-card-item-content-subtitle"
                                                *ngIf="getStatusDateTime(item).time">
                                                {{getStatusDateTime(item).time}}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="dash-card-item-buttons">
                                            <!-- Botão Reenviar -->
                                            <app-tooltip text="Reenviar convite"
                                                position="top"
                                                *ngIf="item.status !== 'used' && !item.canceled && item.status !== 'canceled'">
                                                <button class="dash-item-button"
                                                    (click)="handleResendInvite(item.id)">
                                                    <i
                                                        class="fas fa-paper-plane"></i>
                                                </button>
                                            </app-tooltip>

                                            <app-spacer [right]="16"
                                                *ngIf="item.status !== 'used' && !item.canceled && item.status !== 'canceled'"></app-spacer>

                                            <!-- Botão Cancelar -->
                                            <app-tooltip text="Cancelar convite"
                                                position="top"
                                                *ngIf="item.status !== 'used' && !item.canceled && item.status !== 'canceled'">
                                                <button class="dash-item-button"
                                                    (click)="handleShowCancelModal(item.id)">
                                                    <svg-icon
                                                        src="assets/images/icon-ban.svg"></svg-icon>
                                                </button>
                                            </app-tooltip>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <ng-container *ngIf="hasFilters">

                            <div class="col-12"
                                *ngIf="invites.length === 0 && !loading">
                                <app-empty-content [isVisible]="true"
                                    title="Não encontramos resultados para sua busca"
                                    description="Não há registros para o termo digitado, verifique a ortografia ou tente novamente com outras palavras"
                                    icon="/assets/images/figure_3d_search.png">
                                </app-empty-content>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="!hasFilters">
                            <div class="row no-gutters"
                                *ngIf="invites.length === 0 && !loading">
                                <div class="col-12">
                                    <app-empty-content [isVisible]="true"
                                        title="Nenhum convite encontrado"
                                        description="Você ainda não possui convites enviados"
                                        icon="/assets/images/star.png">
                                    </app-empty-content>
                                </div>
                            </div>
                        </ng-container>

                        <!-- <ng-container *ngIf="filtered">
                <div class="empty-card"
                    *ngIf="invites.length === 0 && !loading">
                    <div class="img-container">
                        <img src="/assets/images/figure_3d_search.png"
                            alt="icone">
                    </div>
                    <app-spacer [bottom]="48"></app-spacer>

                    <h3>Não encontramos resultados para sua busca</h3>
                    <p>
                        Não há registros para o termo digitado, verifique a
                        ortografia ou tente novamente com outras
                        palavras
                    </p>
                </div>
            </ng-container> -->
                    </div>

                    <div class="pb-4"></div>
                </div>
            </div>

            <div class="dash-card-pagination" *ngIf="invites.length > 0">
                <app-pagination [data]="invites" [count]="count"
                    [show]="!loading" [offset]="showing_to"
                    [resultsPerPage]="resultsPerPage"
                    (onPageChange)="changePageData($event)"
                    [dashPagination]="true">
                </app-pagination>
            </div>
        </div>
    </div>
</div>


<app-carbon-warning-modal [active]="showCancelModal" [title]="'Atenção'"
    [message]="getCancelModalMessage()" [confirmText]="'Sim, cancelar convite'"
    [cancelText]="'Cancelar'" [confirmAction]="cancelInvite.bind(this)"
    [cancelAction]="handleShowCancelModal.bind(this)"
    (onClose)="handleShowCancelModal()">
</app-carbon-warning-modal>

<app-carbon-warning-modal [active]="showModal2" [title]="'Verificar Documento'"
    [customContent]="true" (onClose)="toggleModal2()">

    <form [formGroup]="modal2Form">
        <p
            style="color: #161616; font-size: 18px; line-height: 28px; margin-bottom: 24px;">
            Comece inserindo o CPF ou CNPJ. Assim, a plataforma verifica se já
            existe um registro ou se será criado um novo.
        </p>

        <app-masked-input [group]="modal2Form" controlName="document"
            label="CPF/CNPJ" placeholder="Digite o CPF ou CNPJ" mask="CPF_CNPJ">
        </app-masked-input>
        <app-spacer [bottom]="24"></app-spacer>

        <div class="row" style="margin-top: 24px;">
            <div class="col-12 col-lg-6">
                <app-button (onClick)="toggleModal2()" [phantom]="true"
                    style="width: 100%;">
                    Cancelar
                </app-button>
            </div>

            <div class="col-12 col-lg-6 d-flex justify-content-lg-end">
                <app-button (onClick)="handleModal2Action()" class="add-button"
                    [disabled]="getModal2Disabled()" style="width: 100%;">
                    Verificar
                    <svg-icon src="assets/images/icon-arrow-right.svg"
                        class="ml-2"></svg-icon>
                </app-button>
            </div>
        </div>
    </form>
</app-carbon-warning-modal>



<app-side-filter-modal [active]="showFilterModal" [formGroup]="filterForm"
    [loading]="loading" title="Filtrar listagem"
    [disableApplyButton]="!canApplyFilters" (onClose)="toggleFilterModal()"
    (onApply)="filterData()" (onReset)="resetForm()">
    <div class="row">
        <div class="col-12">
            <app-input [group]="filterForm" controlName="name"
                label="Nome / Razão Social" placeholder="Digite">
            </app-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-input type="email" label="E-mail" [group]="filterForm"
                [alwaysValid]="true" controlName="email" placeholder="Digite">
            </app-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-masked-input [group]="filterForm" controlName="document"
                label="CPF / CNPJ" mask="CPF_CNPJ" placeholder="Digite">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-select [items]="statusFilterOptions" [group]="filterForm"
                controlName="status" placeholder="Selecione" label="Status">
            </app-select>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
    </div>
</app-side-filter-modal>

<app-side-modal [active]="newInvite"
    [title]="editing ? 'Reenviar convite' : 'Novo convite'"
    (onClose)="closeModal()">
    <form [formGroup]="form">
        <div class="row">
            <!-- Campo de documento - primeiro campo -->
            <div class="col-12">
                <p *ngIf="!documentVerified && !editing && !checkingDocument"
                    style="color: #161616; font-size: 14px; line-height: 20px; margin-bottom: 24px;">
                    Comece inserindo o CPF ou CNPJ. Assim, a plataforma verifica
                    se já existe um registro ou se será criado um novo.
                </p>
                <p *ngIf="documentVerified && !editing && !isCollaborator && !hasPendingApproval && !hasInviteSent && !hasRoleDraft && !documentExists && approvedRoles.length === 0"
                    style="color: #161616; font-size: 14px; line-height: 20px; margin-bottom: 24px;">
                    Este {{ getDocumentType() }} não possui cadastro. Informe os
                    dados necessários para prosseguir com o convite.
                </p>
                <p *ngIf="documentVerified && !editing && !isCollaborator && !hasPendingApproval && !hasInviteSent && !hasRoleDraft && approvedRoles.length > 0"
                    style="color: #161616; font-size: 14px; line-height: 20px; margin-bottom: 24px;">
                    Cadastro identificado como <strong>{{ getApprovedRolesText()
                        }}</strong>.
                    Complete
                    as informações para prosseguir com o convite.
                </p>
                <app-masked-input [group]="form" controlName="document"
                    label="CPF / CNPJ" mask="CPF_CNPJ"
                    [readOnly]="inviteId || checkingDocument"
                    placeholder="Digite o CPF ou CNPJ">
                </app-masked-input>
                <div *ngIf="documentInviteError" class="error-message"
                    style="color: #e74c3c; font-size: 12px; margin-top: 8px;">
                    {{ documentInviteError }}
                </div>

                <!-- Loading durante verificação do documento -->
                <div class="col-12 text-center" *ngIf="checkingDocument">
                    <p style="color: var(--dark); font-size: var(--font-sm);">
                        <svg-icon src="assets/images/icon-loading.svg"
                            fill="var(--dark)"
                            style="font-size: 24px;"></svg-icon> Verificando
                        documento...
                    </p>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Aviso quando é colaborador -->
                <div class="col-12 mt-2" style="padding: 0;"
                    *ngIf="documentExists && !checkingDocument && isCollaborator && collaboratorInfo">
                    <!-- Alerta principal - destaque -->
                    <div
                        style="background-color: #fff3cd; border-left: 4px solid #ffc107; padding: 16px; border-radius: 8px; margin-bottom: 16px;">
                        <div
                            style="display: flex; align-items: center; gap: 12px;">
                            <svg-icon src="assets/images/icon-warning.svg"
                                fill="var(--warning)"
                                style="color: #ff9800; font-size: 24px;"></svg-icon>
                            <div>
                                <p
                                    style="margin: 0; color: #856404; font-size: var(--font-md); font-weight: 600; line-height: 1.4;">
                                    Cadastro não permitido
                                </p>
                                <p
                                    style="margin: 4px 0 0 0; color: #856404; font-size: var(--font-sm); line-height: 1.5;">
                                    Esta pessoa já está cadastrada como
                                    <strong>colaborador</strong> e não pode ser
                                    cadastrada como cedente, cotista ou outro
                                    papel.
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Card com informações do colaborador - compacto -->
                    <div
                        style="background-color: var(--main); padding: 14px; border-radius: 8px; margin-bottom: 16px;">
                        <div
                            style="display: flex; align-items: center; gap: 10px; margin-bottom: 12px;">
                            <svg-icon src="assets/images/icon-user.svg"
                                fill="white"
                                style="color: white; font-size: 22px;"></svg-icon>
                            <p
                                style="margin: 0; color: white; font-size: var(--font-lg); font-weight: 600;">
                                {{ collaboratorInfo.name }} • {{
                                getCollaboratorDocument() }}
                            </p>
                        </div>

                        <!-- Se for Master ou Owner, mostra apenas Tipo de acesso e Empresa -->
                        <div *ngIf="collaboratorInfo.collaborator_type === 'master' || collaboratorInfo.collaborator_type === 'owner'"
                            style="display: grid; grid-template-columns: 1fr; gap: 10px; font-size: var(--font-xs);">
                            <div>
                                <p
                                    style="margin: 0; color: rgba(255, 255, 255, 0.8); font-weight: 500;">
                                    Tipo de acesso</p>
                                <p style="margin: 2px 0 0 0; color: white;">{{
                                    getCollaboratorType() }}</p>
                            </div>

                            <div>
                                <p
                                    style="margin: 0; color: rgba(255, 255, 255, 0.8); font-weight: 500;">
                                    Empresa</p>
                                <p style="margin: 2px 0 0 0; color: white;">
                                    Banvox Distribuidora de Títulos e Valores
                                    Mobiliários Ltda
                                </p>
                            </div>
                        </div>

                        <!-- Se não for Master ou Owner, mostra Tipo de acesso e Empresa (sem Perfil) -->
                        <div *ngIf="collaboratorInfo.collaborator_type !== 'master' && collaboratorInfo.collaborator_type !== 'owner'"
                            style="display: grid; grid-template-columns: 1fr; gap: 10px; font-size: var(--font-xs);">
                            <div>
                                <p
                                    style="margin: 0; color: rgba(255, 255, 255, 0.8); font-weight: 500;">
                                    Tipo de acesso</p>
                                <p style="margin: 2px 0 0 0; color: white;">{{
                                    getCollaboratorType() }}</p>
                            </div>

                            <div>
                                <p
                                    style="margin: 0; color: rgba(255, 255, 255, 0.8); font-weight: 500;">
                                    Empresa</p>
                                <p style="margin: 2px 0 0 0; color: white;">
                                    Banvox Distribuidora de Títulos e Valores
                                    Mobiliários Ltda
                                </p>
                            </div>

                            <div
                                *ngIf="collaboratorInfo.departments && collaboratorInfo.departments.length > 0">
                                <p
                                    style="margin: 0; color: rgba(255, 255, 255, 0.8); font-weight: 500;">
                                    Departamento</p>
                                <p style="margin: 2px 0 0 0; color: white;">{{
                                    getCollaboratorDepartments() }}</p>
                            </div>
                        </div>
                    </div>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Aviso quando há aprovação pendente -->
                <div class="col-12 mt-2" style="padding: 0;"
                    *ngIf="documentExists && !checkingDocument && hasPendingApproval && pendingApprovalRole && !hasInviteSent">
                    <!-- Alerta principal - destaque -->
                    <div
                        style="background-color: #fff3cd; border-left: 4px solid #ffc107; padding: 16px; border-radius: 8px; margin-bottom: 16px;">
                        <div
                            style="display: flex; align-items: center; gap: 12px;">
                            <svg-icon src="assets/images/icon-warning.svg"
                                fill="var(--warning)"
                                style="color: #ff9800; font-size: 24px;"></svg-icon>
                            <div>
                                <p
                                    style="margin: 0; color: #856404; font-size: var(--font-md); font-weight: 600; line-height: 1.4;">
                                    Cadastro já existe
                                </p>
                                <p
                                    style="margin: 4px 0 0 0; color: #856404; font-size: var(--font-sm); line-height: 1.5;">
                                    Não é possível adicionar um novo papel pois
                                    o cadastro como <strong>{{
                                        pendingApprovalRole }}</strong> ainda
                                    não foi aprovado.
                                </p>
                            </div>
                        </div>
                    </div>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Aviso quando há convite já enviado (used ou viewed) -->
                <div class="col-12 mt-2" style="padding: 0;"
                    *ngIf="documentExists && !checkingDocument && hasInviteSent && inviteStatus">
                    <!-- Alerta principal - destaque -->
                    <div
                        style="background-color: #fff3cd; border-left: 4px solid #ffc107; padding: 16px; border-radius: 8px; margin-bottom: 16px;">
                        <div
                            style="display: flex; align-items: center; gap: 12px;">
                            <svg-icon src="assets/images/icon-warning.svg"
                                fill="var(--warning)"
                                style="font-size: 24px;"></svg-icon>
                            <div>
                                <p
                                    style="margin: 0; color: #856404; font-size: var(--font-md); font-weight: 600; line-height: 1.4;">
                                    Convite já enviado
                                </p>
                                <p
                                    style="margin: 4px 0 0 0; color: #856404; font-size: var(--font-sm); line-height: 1.5;">
                                    Um convite já foi enviado ao usuário<span
                                        *ngIf="invitedData?.sender_name"> por
                                        <strong>{{
                                            invitedData.sender_name
                                            }}</strong></span>. Não
                                    é
                                    possível convidá-lo novamente enquanto ele
                                    não concluir o cadastro.
                                </p>
                            </div>
                        </div>
                    </div>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Aviso quando há role_draft (adição de papel em andamento) -->
                <div class="col-12 mt-2" style="padding: 0;"
                    *ngIf="!checkingDocument && hasRoleDraft && roleDraftInfo">
                    <!-- Alerta principal - destaque -->
                    <div
                        style="background-color: #fff3cd; border-left: 4px solid #ffc107; padding: 16px; border-radius: 8px; margin-bottom: 16px;">
                        <div
                            style="display: flex; align-items: center; gap: 12px;">
                            <svg-icon src="assets/images/icon-warning.svg"
                                fill="var(--warning)"
                                style="font-size: 24px;"></svg-icon>
                            <div>
                                <p
                                    style="margin: 0; color: #856404; font-size: var(--font-md); font-weight: 600; line-height: 1.4;">
                                    Adição de papel em andamento
                                </p>
                                <p
                                    style="margin: 4px 0 0 0; color: #856404; font-size: var(--font-sm); line-height: 1.5;">
                                    Não é possível adicionar um novo papel pois
                                    a adição do papel <strong>{{
                                        roleDraftInfo.applicable_display ||
                                        roleDraftInfo.name }}</strong> está
                                    em andamento.
                                </p>
                            </div>
                        </div>
                    </div>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Aviso quando todos os papéis já foram adicionados -->
                <div class="col-12 mt-2" style="padding: 0;"
                    *ngIf="documentVerified && !checkingDocument && !editing && !hasRoleDraft && !documentInviteError && approvedRoles.length > 0 && unifiedRoleOptions.length === 0">
                    <!-- Alerta principal - destaque -->
                    <div
                        style="background-color: #fff3cd; border-left: 4px solid #ffc107; padding: 16px; border-radius: 8px; margin-bottom: 16px;">
                        <div
                            style="display: flex; align-items: center; gap: 12px;">
                            <svg-icon src="assets/images/icon-warning.svg"
                                fill="var(--warning)"
                                style="color: #ff9800; font-size: 24px;"></svg-icon>
                            <div>
                                <p
                                    style="margin: 0; color: #856404; font-size: var(--font-md); font-weight: 600; line-height: 1.4;">
                                    Todos os papéis já foram adicionados
                                </p>
                                <p
                                    style="margin: 4px 0 0 0; color: #856404; font-size: var(--font-sm); line-height: 1.5;">
                                    Todos os papéis possíveis já foram
                                    adicionados a este usuário. Não é possível
                                    criar um novo convite.
                                </p>
                            </div>
                        </div>
                    </div>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Informação se o documento já existe (não é colaborador, sem aprovação pendente, sem convite enviado, sem role_draft e sem papéis aprovados) -->
                <div class="col-12 mt-2" style="padding: 0;"
                    *ngIf="documentExists && !checkingDocument && !isCollaborator && !hasPendingApproval && !hasInviteSent && !hasRoleDraft && !approvedRoles.length && userName">
                    <!-- Alerta informativo - cadastro já existe -->
                    <div
                        style="background-color: #e3f2fd; border-left: 4px solid #2196f3; padding: 16px; border-radius: 8px; margin-bottom: 16px;">
                        <div
                            style="display: flex; align-items: center; gap: 12px;">
                            <svg-icon src="assets/images/icon-info.svg"
                                fill="#1976d2"
                                style="font-size: 24px;"></svg-icon>
                            <div>
                                <p
                                    style="margin: 0; color: #0d47a1; font-size: var(--font-md); font-weight: 600; line-height: 1.4;">
                                    Cadastro já realizado
                                </p>
                                <p
                                    style="margin: 4px 0 0 0; color: #1565c0; font-size: var(--font-sm); line-height: 1.5;">
                                    Esta pessoa já possui cadastro no sistema
                                    com os papéis abaixo.
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Card com informações do usuário - compacto -->
                    <div
                        style="background-color: var(--main); padding: 14px; border-radius: 8px; margin-bottom: 16px;">
                        <div
                            style="display: flex; align-items: center; gap: 10px; margin-bottom: 12px;">
                            <svg-icon src="assets/images/icon-user-check.svg"
                                style="color: white; font-size: 22px;"></svg-icon>
                            <p
                                style="margin: 0; color: white; font-size: var(--font-lg); font-weight: 600;">
                                {{ userName }} • {{
                                form.controls.document.value }}
                            </p>
                        </div>

                        <div style="display: grid; grid-template-columns: 1fr; gap: 10px; font-size: var(--font-xs);"
                            *ngIf="currentPapers.length > 0">
                            <div>
                                <p
                                    style="margin: 0; color: rgba(255, 255, 255, 0.8); font-weight: 500;">
                                    Papel atual</p>
                                <p
                                    style="margin: 4px 0 0 0; color: white; line-height: 1.6;">
                                    {{ getCurrentPapersText() }}</p>
                            </div>
                        </div>
                    </div>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Mensagem de cadastro identificado (para convite usado existente) -->
                <div *ngIf="documentVerified && !documentInviteError && !editing && existingInviteData && approvedRoles.length === 0"
                    style="margin-top: 8px; padding-left: 4px; border-left: 3px solid var(--main, #001030);">
                    <p
                        style="color: #161616; font-size: 14px; line-height: 20px; margin: 0;">
                        Cadastro identificado como {{
                        getInviteTypeLabel(existingInviteData.type) }}. Complete
                        as informações para prosseguir com o convite.
                    </p>
                </div>

                <app-spacer [bottom]="16"></app-spacer>
            </div>


            <!-- Campos - só aparecem após verificação do documento sem erro, sem role_draft e quando há papéis disponíveis -->
            <ng-container
                *ngIf="(documentVerified || inviteId) && !hasRoleDraft && !(documentVerified && approvedRoles.length > 0 && unifiedRoleOptions.length === 0)">
                <!-- Nome primeiro -->
                <div class="col-12">
                    <app-input [group]="form" controlName="name"
                        [label]="existingInviteData ? (existingInviteData.person_type === 'PF' ? 'Nome completo' : 'Razão Social') : (currentPersonType === 'PF' ? 'Nome completo' : (currentPersonType === 'PJ' ? 'Razão Social' : (getDocumentType() === 'CPF' ? 'Nome completo' : 'Razão Social')))"
                        placeholder="Digite" [maxLength]="60"
                        [readOnly]="inviteId || existingInviteData">
                    </app-input>
                    <!-- Badges dos papéis aprovados -->
                    <div *ngIf="documentVerified && !documentInviteError && !editing && approvedRoles.length > 0"
                        style="margin-top: 8px; display: flex; flex-wrap: wrap; gap: 8px;">
                        <span *ngFor="let role of approvedRoles"
                            style="background-color: var(--main, #001030); color: white; padding: 6px 12px; border-radius: 4px; font-size: 12px; font-weight: 600; display: inline-block;">
                            {{ role.applicable_display }}
                        </span>
                    </div>
                    <!-- Badge quando há convite usado existente (não há papéis aprovados) -->
                    <div *ngIf="documentVerified && !documentInviteError && !editing && existingInviteData && approvedRoles.length === 0"
                        style="margin-top: 8px; display: flex; flex-wrap: wrap; gap: 8px;">
                        <span *ngIf="existingInviteData.type === 'assignor'"
                            style="background-color: var(--main, #001030); color: white; padding: 6px 12px; border-radius: 4px; font-size: 12px; font-weight: 600; display: inline-block;">
                            Cedente
                        </span>
                        <span *ngIf="existingInviteData.type === 'shareholder'"
                            style="background-color: var(--main, #001030); color: white; padding: 6px 12px; border-radius: 4px; font-size: 12px; font-weight: 600; display: inline-block;">
                            Cotista
                        </span>
                        <span *ngIf="existingInviteData.type === 'provider'"
                            style="background-color: var(--main, #001030); color: white; padding: 6px 12px; border-radius: 4px; font-size: 12px; font-weight: 600; display: inline-block;">
                            Prestador de Serviço
                        </span>
                    </div>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Email -->
                <div class="col-12">
                    <app-input type="email"
                        label="Email a ser enviado o convite" [group]="form"
                        controlName="email">
                    </app-input>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Papel -->
                <div class="col-12">
                    <app-select label="Selecione o papel" [group]="form"
                        controlName="unified_role" [items]="unifiedRoleOptions"
                        placeholder="Selecione" [readOnly]="inviteId">
                    </app-select>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Agente (só aparece se for provider ou se houver dados existentes de provider) -->
                <div class="col-12"
                    *ngIf="hasRole('provider') || existingInviteData?.type === 'provider'">
                    <app-select label="Agente" [group]="form"
                        controlName="agent" [items]="agentOptions"
                        [multiple]="true"
                        [readOnly]="inviteId && form.controls.agent.value && form.controls.agent.value.length > 0">
                    </app-select>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Fundo de interesse (aparece para todos, mas é obrigatório apenas se não for provider) -->
                <div class="col-12">
                    <app-select label="Fundo de interesse" [group]="form"
                        controlName="fund" [items]="fundOptions"
                        placeholder="Selecione" [readOnly]="existingInviteData">
                    </app-select>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </ng-container>
        </div>

        <div class="row button-sticky">
            <div class="col-12 col-lg-6">
                <app-button (onClick)="closeModal()" [phantom]="true">
                    Cancelar
                </app-button>
            </div>

            <div class="col-12 col-lg-6">
                <div class="text-right">
                    <!-- Botão Verificar - aparece antes da verificação do documento -->
                    <app-button
                        *ngIf="!documentVerified && !editing && !hasRoleDraft"
                        (onClick)="verifyDocument()" class="add-button"
                        [disabled]="!canVerifyDocument() || checkingDocument"
                        [loading]="checkingDocument">
                        Verificar
                    </app-button>

                    <!-- Botão Disparar/Reenviar - aparece após verificação ou quando está editando (mas não quando há role_draft) -->
                    <app-button
                        *ngIf="(documentVerified || editing) && !hasRoleDraft"
                        (onClick)="editing ? resendInvite() : sendInvite()"
                        class="add-button" [disabled]="getDisabled()"
                        [loading]="sendingInvite">
                        {{editing ? 'Reenviar convite' : 'Disparar convite'}}
                    </app-button>
                </div>
            </div>
        </div>
    </form>
</app-side-modal>

<app-side-modal [active]="inviteDetails !== null" title="Convite"
    (onClose)="closeModal()" paddingBottom="30">
    <div class="container" *ngIf="inviteDetails !== null">
        <div class="row">
            <div class="col-12 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    Nome / Razão social
                </span>

                <span class="dash-details-card-item-title">
                    {{inviteDetails.name}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    CPF / CNPJ
                </span>

                <span class="dash-details-card-item-title">
                    {{inviteDetails.document}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    Email
                </span>

                <span class="dash-details-card-item-title">
                    {{inviteDetails.email}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    Papel
                </span>

                <span class="dash-details-card-item-title">
                    {{getTypeDisplay(inviteDetails.type)}}
                </span>
                <span class="dash-details-card-item-subtitle"
                    *ngIf="getPersonTypeDisplay(inviteDetails.person_type)">
                    {{getPersonTypeDisplay(inviteDetails.person_type)}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 d-flex flex-column"
                *ngIf="inviteDetails.type === 'provider'">
                <span class="dash-details-card-item-subtitle">
                    Função do prestador
                </span>

                <span class="dash-details-card-item-title">
                    {{displayAgents(inviteDetails.agent)}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    Fundo de interesse
                </span>

                <span class="dash-details-card-item-title">
                    {{inviteDetails.fund_interest_name || '-'}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    Inteção do convite
                </span>

                <span class="dash-details-card-item-title">
                    {{inviteDetails.intent_display}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    Status
                </span>

                <span class="dash-details-card-item-title">
                    {{displayStatus(inviteDetails).status}}
                </span>
                <span class="dash-details-card-item-subtitle"
                    *ngIf="displayStatus(inviteDetails).dateTime">
                    {{displayStatus(inviteDetails).dateTime.date}}
                    <br>
                    {{displayStatus(inviteDetails).dateTime.time}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12 d-flex flex-column">
                <span class="dash-details-card-item-subtitle">
                    Data de expiração
                </span>

                <span class="dash-details-card-item-title">
                    {{displayExpirationDate(inviteDetails.created_at)}}
                </span>
                <app-spacer [bottom]="16"></app-spacer>
            </div>
        </div>
    </div>
</app-side-modal>